export default {
  purchaseDate: {
    id: 'insurance_policy_details_purchase_date',
    defaultMessage: 'Purchased on {date}',
  },
  imei: {
    id: 'insurance_policy_details_imei',
    defaultMessage: 'IMEI: {imei}',
  },
  coverageSince: {
    id: 'insurance_policy_details_coverage_since',
    defaultMessage: 'Coverage since',
  },
  expires: {
    id: 'insurance_policy_details_expires',
    defaultMessage: 'Expires',
  },
  cancelled: {
    id: 'insurance_policy_details_cancelled',
    defaultMessage: 'Cancelled',
  },
  backLabel: {
    id: 'insurance_policy_details_back_label',
    defaultMessage: 'All Protection Plans',
  },
  cancellationReason: {
    id: 'insurance_policy_details_cancellation_reason',
    defaultMessage: 'Cancellation reason',
  },
  serialNumber: {
    id: 'insurance_policy_details_serial_number',
    defaultMessage: 'Serial number: {serialNumber}',
  },
  policyWithdrawal: {
    id: 'cancellation_reason_policyholder',
    defaultMessage: 'Canceled by policyholder',
  },
  policyCancellation: {
    id: 'cancellation_reason_policyholder',
    defaultMessage: 'Canceled by policyholder',
  },
  orderlineWithdrawal: {
    id: 'cancellation_reason_orderline_refunded',
    defaultMessage: 'Device returned',
  },
  orderlineCancellation: {
    id: 'cancellation_reason_orderline_refunded',
    defaultMessage: 'Device returned',
  },
  orderlineReturn: {
    id: 'cancellation_reason_orderline_refunded',
    defaultMessage: 'Device returned',
  },
  failingPaymentOccurrence: {
    id: 'cancellation_reason_unpaid_premium',
    defaultMessage: 'Payment not made',
  },
  theft: {
    id: 'cancellation_reason_theft',
    defaultMessage: 'Stolen device',
  },
  death: {
    id: 'cancellation_reason_policyholder',
    defaultMessage: 'Canceled by policyholder',
  },
  riskDisappearance: {
    id: 'cancellation_reason_risk_disappearence',
    defaultMessage: 'Device lost',
  },
  other: {
    id: 'cancellation_reason_insurer',
    defaultMessage: 'Canceled by insurer',
  },
  chargeback: {
    id: 'cancellation_reason_insurer',
    defaultMessage: 'Canceled by insurer',
  },
  fraud: {
    id: 'cancellation_reason_insurer',
    defaultMessage: 'Canceled by insurer',
  },
  replacement: {
    id: 'cancellation_reason_replacement',
    defaultMessage: 'Coverage limit reached',
  },
  subscriptionNotAccepted: {
    id: 'cancellation_reason_subscription_not_accepted',
    defaultMessage: 'Canceled by insurer',
  },
  policyExpired: {
    id: 'cancellation_reason_policy_expired',
    defaultMessage: 'Contract expired',
  },
  paymentFailed: {
    id: 'cancellation_reason_payment_failed',
    defaultMessage: 'Payment not made',
  },
  autoRenew: {
    id: 'insurance_policy_details_auto_renew',
    defaultMessage: 'Auto-renew',
  },
}
